import React, { FC, useMemo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Segment } from "@lookiero/sty-psp-segment";
import { Text } from "@lookiero/sty-psp-ui";
import { style as nextBestActionTitleStyle } from "./NextBestActionTitle.style";

interface NextBestActionTitleProps {
  readonly domain: string;
  readonly translationKey: string;
  readonly segment: Segment;
}

const NextBestActionTitle: FC<NextBestActionTitleProps> = ({ domain, translationKey, segment }) => {
  const titleText = useI18nMessage({ domain, id: translationKey, values: { segment: segment.toLowerCase() } });

  const style = useMemo(() => nextBestActionTitleStyle(), []);

  return (
    <Text level={2} style={style.title} variant="action">
      {titleText}
    </Text>
  );
};

export { NextBestActionTitle };
